// import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { resetStaleAuthStorage } from './app/auth-bootstrap';
import { environment } from './environments/environment';
import { AuthService } from './app/core/auth.service';

resetStaleAuthStorage();

// bootstrapApplication(AppComponent, appConfig)
platformBrowserDynamic().bootstrapModule(AppModule)
.then((ref) => {
  // Signal in-app feedback: the standard snippet. `environment.signal` is null where the widget is disabled.
  const signal = (environment as { signal?: { scriptUrl: string; apiBase: string; appKey: string; env: string } | null }).signal;
  if (!signal) return;
  const auth = ref.injector.get(AuthService);
  window.cbreSignalSettings = {
    appKey: signal.appKey,
    apiBase: signal.apiBase,
    env: signal.env,
    appVersion: 'dev',
    loadFonts: true,
    captureHttp: true,
    tokenProvider: () => auth.getAccessToken(),
    userName: () => {
      const p = auth.oktaUserProfile as { name?: string; given_name?: string; family_name?: string } | undefined;
      return p ? (p.name || [p.given_name, p.family_name].filter(Boolean).join(' ')).trim() : '';
    },
  };
  const tag = document.createElement('script');
  tag.src = signal.scriptUrl;
  tag.defer = true;
  document.head.appendChild(tag);
})
.catch((err) => console.error(err));

declare global {
  interface Window {
    cbreSignalSettings?: {
      appKey: string; apiBase: string; env?: string; appVersion?: string; loadFonts?: boolean; captureHttp?: boolean;
      tokenProvider?: () => Promise<string | null> | string | null;
      userName?: string | (() => string); userRole?: string | (() => string);
    };
  }
}